import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { http } from "../../lib/api";
import { Logo } from "../../components/site/Logo";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState(""), [password, setPassword] = useState(""), [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try { const r = await http.post("/auth/login", { email, password }); onLogin(r.data); }
    catch (err) { const d = err.response?.data?.detail; setError(typeof d === "string" ? d : "Unable to sign in"); }
  };
  return (
    <main className="auth-screen">
      <div className="auth-panel">
        <Logo />
        <p className="eyebrow">Operations console</p><h1>Admin sign in</h1>
        <p>Manage enquiries, analytics, WhatsApp and email activity.</p>
        <form onSubmit={submit} data-testid="admin-login-form">
          <label>Email<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" /></label>
          <label>Password<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" /></label>
          {error && <div className="form-error" data-testid="admin-login-error">{error}</div>}
          <button className="button button-orange full" data-testid="admin-login-submit">Open CRM <ArrowRight size={17} /></button>
        </form>
        <Link to="/" className="back-link" data-testid="back-to-site-link">← Back to website</Link>
      </div>
    </main>
  );
}
